import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { dismissWeatherBanner } from '../../../store/weather';
import styles from './index.module.css';

export const WeatherAlertBanner = () => {
  const dispatch = useDispatch();
  const { hasAlert, alerts, locations, dismissed } = useSelector((state) => state.weather);

  if (!hasAlert || dismissed) return null;

  const alertText = locations?.length > 0
    ? locations.map((l) => `${l.locationName}: ${l.headline}`).join(' | ')
    : (alerts[0]?.headline ?? 'Inclement weather conditions detected in your area.');

  return (
    <div className={styles.banner}>
      <span className={styles.icon}>&#9888;</span>
      <span className={styles.text}>
        <strong>Inclement Weather Alert:</strong>{' '}
        {alertText}
      </span>
      <button
        className={styles.closeBtn}
        onClick={() => dispatch(dismissWeatherBanner())}
        aria-label="Dismiss weather alert">
        &times;
      </button>
    </div>
  );
};
